import { render, staticRenderFns } from "./ImportAddressDataModal.vue?vue&type=template&id=f66cb27e&scoped=true&"
import script from "./ImportAddressDataModal.vue?vue&type=script&lang=js&"
export * from "./ImportAddressDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66cb27e",
  null
  
)

export default component.exports